// frontend/src/components/HeaderBar.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AvatarMenu from './AvatarMenu';
import NotificationBell from './NotificationBell';
import TopMenu from './TopMenu';
import { useAppBackground } from '../context/AppBackgroundContext';
import { useI18n } from '../i18n';
import './HeaderBar.css';
import LieDetectorDot from './LieDetectorDot';

export default function HeaderBar({
  logout,
  user,
  updateUserAvatar,
  questionnaireState
}) {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [topMenuOpen, setTopMenuOpen] = useState(false);
  const { hasBackground, settings, cycleHeaderMode } = useAppBackground() || {};

  const [hideHeader, setHideHeader] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const currentY = window.scrollY;
      setHideHeader(currentY > lastScrollY.current && currentY > 80);
      lastScrollY.current = currentY;
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const menuButtonRef = useRef();
  useEffect(() => {
    const onClickOutside = e => {
      // Si el click/pulsación ocurrió dentro del área de header-right (menuButtonRef) no tocamos nada.
      if (menuButtonRef.current && menuButtonRef.current.contains(e.target)) return;

      // SI ocurrió dentro del propio TopMenu (dropdown) no cerramos aquí:
      // evita que el menú se desmonte antes de que se ejecute el handler del botón dentro del TopMenu.
      const clickedInTopMenu = !!(e.target && e.target.closest && e.target.closest('.topmenu-container'));
      if (clickedInTopMenu) return;

      // else: click fuera -> cerramos
      setTopMenuOpen(false);
    };

    // usamos mousedown para que responda rápido, pero con la comprobación anterior ya es seguro.
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  return (
    <>
      <header className={`header-bar ${hideHeader ? 'hidden' : ''}`}>
        <div className="header-left">
          <AvatarMenu
            logout={logout}
            user={user}
            updateUserAvatar={updateUserAvatar}
            hasBackground={hasBackground}
            settings={settings}
            onCycleBackgroundMode={cycleHeaderMode}
          />
          <LieDetectorDot />
        </div>

        <div className="header-center" onClick={() => navigate('/')}>
          <h1 className="logo">
            <img src="/antakarana.svg" alt="Quiddit" className="logo-img" />
          </h1>
        </div>

        <div className="header-right" ref={menuButtonRef}>
          <NotificationBell />
          <button
            className="menu-button"
            onClick={() => setTopMenuOpen(open => !open)}
            aria-label={t('nav.openMenu')}
          >
            <span className="menu-icon-hamburger">☰</span>
            <span className="menu-icon-dots">⋮</span>
          </button>
        </div>
      </header>

      {/* TopMenu es controlado por props open/onClose */}
      <TopMenu open={topMenuOpen} onClose={() => setTopMenuOpen(false)} />
    </>
  );
}
